import React from 'react';
import DefaultMessagesContainer from '../../components/admin/defaultMessges/DefaultMessgaes';

const DefaultMessages = () => {
  return <DefaultMessagesContainer />;
};

export default DefaultMessages;
